module.exports = __webpack_public_path__ + "static/media/Public_50.66c04e81.jpg";